export function checkEmpty(value) {
  return value === '' ? undefined : value;
}
